import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  min-height: 47px;
    ${({theme}:IThemeProvider) => `
    padding: ${theme.layout.spacing.mili} 0;
    color: ${theme.colors.neutral.primary[80]};
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
    margin: 0 0 ${theme.layout.spacing.decy} 0;
  `}
`;

export const CategoryColumnTitleCont = styled.div`
  position: relative;
  display: flex;
  margin: 0 16px 0 0;
  flex: 1;
`;

export const CategoryColumnTitle = styled(LabelRegularBoldM)`
  display: inline-block;

  @media (min-width: 1360px) {
    //width: 450px;
  }
  ${({theme}:IThemeProvider) => `
    margin: 0 0 0 ${theme.layout.spacing.peta};
  `}
`;
interface IAccArrowCont {
  active?: boolean;
  inActive?: boolean;
  theme: ITheme;
}

export const CatHeadArrowCont = styled.div<IAccArrowCont>`
  cursor: pointer;
  flex: 2.1;

  svg {
    margin: 0 0 0 7px;
    width: 10px;
    height: 5px;
    position: relative;
    top: -2px;
    ${({ active, theme, inActive }) => `
      ${inActive ? 'opacity: 0.4;' : '' }
      ${active ? `
      transform: rotate(180deg);
      top: -2px;
      ` : ''}
      path {
        fill: ${theme.colors.secondary[100]};
      }
  `};
  }
`;

export const ReportsSpinnerCont = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;

  .ant-spin-dot {
    font-size:60px;

    .ant-spin-dot-item {
      width: 23.83px;
      height: 23.83px;
    }
  }
`;
